/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NamedNodeMap } from './namedNodeMap';
import { Element } from './element';
import { Node } from './node';
import { NodeList } from './nodeList';
import { DOMConfiguration } from './dOMConfiguration';
import { DocumentType } from './documentType';


export interface Document { 
    doctype?: DocumentType;
    inputEncoding?: string;
    xmlEncoding?: string;
    xmlStandalone?: boolean;
    xmlVersion?: string;
    strictErrorChecking?: boolean;
    domConfig?: DOMConfiguration;
    documentURI?: string;
    documentElement?: Element;
    implementation?: object;
    attributes?: NamedNodeMap;
    namespaceURI?: string;
    nodeType?: number;
    localName?: string;
    nodeName?: string;
    nodeValue?: string;
    firstChild?: Node;
    previousSibling?: Node;
    ownerDocument?: Document;
    baseURI?: string;
    textContent?: string;
    childNodes?: NodeList;
    nextSibling?: Node;
    parentNode?: Node;
    lastChild?: Node;
    prefix?: string;
}

